import React from 'react';
import { Truck, CreditCard, Euro, Clock, Package } from 'lucide-react';

function VersandZahlungPage() {
  return (
    <div className="container mx-auto px-4 lg:px-12 py-8 max-w-4xl">
      <h1 className="text-3xl md:text-4xl font-heading font-bold mb-8 uppercase">
        Versand & Zahlung
      </h1>

      <div className="prose prose-gray max-w-none space-y-8">
        {/* Versandkosten */}
        <section className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <Truck className="h-6 w-6 text-primary" />
            <h2 className="text-xl font-bold">Versandkosten</h2>
          </div>
          
          <div className="space-y-4">
            <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg">
              <span className="text-gray-700">Standardversand (Deutschland)</span>
              <span className="font-bold text-lg">6,90 €</span>
            </div>
            
            <div className="flex justify-between items-center p-4 bg-green-50 rounded-lg border border-green-200">
              <div>
                <span className="text-green-800 font-medium">Kostenloser Versand</span>
                <p className="text-green-600 text-sm">ab einem Bestellwert von 200,00 €</p>
              </div>
              <span className="font-bold text-lg text-green-600">0,00 €</span>
            </div>
          </div>

          <p className="text-gray-600 text-sm mt-4">
            Die Versandkosten werden im Warenkorb und während des Bestellvorgangs automatisch 
            berechnet und angezeigt.
          </p>
        </section>

        {/* Lieferzeit */}
        <section className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <Clock className="h-6 w-6 text-primary" />
            <h2 className="text-xl font-bold">Lieferzeit</h2>
          </div>
          
          <p className="text-gray-700">
            Die Lieferzeit beträgt in der Regel <strong>2-5 Werktage</strong> nach 
            Zahlungseingang (bei Vorkasse) bzw. nach Bestellbestätigung (bei Nachnahme).
          </p>
          
          <p className="text-gray-700 mt-3">
            Sollte ein Artikel vorübergehend nicht lieferbar sein, informieren wir Sie 
            umgehend über die voraussichtliche Lieferzeit.
          </p>
        </section>

        {/* Versandgebiet */}
        <section className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <Package className="h-6 w-6 text-primary" />
            <h2 className="text-xl font-bold">Versandgebiet</h2>
          </div>
          
          <p className="text-gray-700">
            Wir liefern derzeit ausschließlich <strong>innerhalb Deutschlands</strong>.
          </p>
          
          <p className="text-gray-700 mt-3">
            Die Lieferung erfolgt über einen Paketdienstleister (z.B. DHL, DPD, Hermes) 
            oder bei größeren Sendungen per Spedition.
          </p>
        </section>

        {/* Zahlungsmethoden */}
        <section className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <CreditCard className="h-6 w-6 text-primary" />
            <h2 className="text-xl font-bold">Zahlungsmethoden</h2>
          </div>
          
          <p className="text-gray-700 mb-4">
            Folgende Zahlungsmethoden stehen Ihnen zur Verfügung:
          </p>

          <div className="space-y-4">
            <div className="p-4 bg-gray-50 rounded-lg">
              <h3 className="font-semibold mb-2">Kreditkarte</h3>
              <p className="text-gray-600 text-sm">
                Visa, Mastercard – sichere Zahlung über Stripe
              </p>
            </div>

            <div className="p-4 bg-gray-50 rounded-lg">
              <h3 className="font-semibold mb-2">PayPal</h3>
              <p className="text-gray-600 text-sm">
                Schnelle und sichere Zahlung mit Ihrem PayPal-Konto
              </p>
            </div>

            <div className="p-4 bg-gray-50 rounded-lg">
              <h3 className="font-semibold mb-2">Nachnahme (Barzahlung bei Lieferung)</h3>
              <p className="text-gray-600 text-sm">
                Zahlung in bar bei Übergabe der Ware an den Zusteller
              </p>
            </div>
          </div>
        </section>

        {/* Währung */}
        <section className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-center gap-3 mb-4">
            <Euro className="h-6 w-6 text-primary" />
            <h2 className="text-xl font-bold">Währung</h2>
          </div>
          
          <p className="text-gray-700">
            Alle Preise und Zahlungen erfolgen ausschließlich in <strong>Euro (€)</strong>.
          </p>
        </section>

        {/* Hinweis B2B */}
        <section className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg">
          <h2 className="text-lg font-bold text-amber-800 mb-2">Hinweis für Geschäftskunden</h2>
          <p className="text-amber-700">
            Unser Angebot richtet sich ausschließlich an Gewerbetreibende (B2B). 
            Die angezeigten Preise verstehen sich als Nettopreise zuzüglich der 
            gesetzlichen Mehrwertsteuer, sofern diese anfällt.
          </p>
        </section>

        {/* Fragen */}
        <section className="bg-gray-50 rounded-lg p-6">
          <h2 className="text-xl font-bold mb-4">Fragen zum Versand?</h2>
          <p className="text-gray-700">
            Bei Fragen zu Lieferung oder Zahlung erreichen Sie uns unter:
          </p>
          <div className="mt-4">
            <p className="text-gray-700">
              <strong>E-Mail:</strong> ed-steel@outlook.de<br />
              <strong>Telefon:</strong> +49 171 629 5816
            </p>
          </div>
        </section>

        {/* Stand */}
        <section className="pt-4 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            Stand: Februar 2026
          </p>
        </section>
      </div>
    </div>
  );
}

export default VersandZahlungPage;
